module.exports = "../images/icons/mail-notification-contact-icon.png";